export const onlineBenefits = {
  essentials: [
    { label: 'Base Storage Included', value: '5TB' },
    { label: 'Cloud Platforms Support (AWS S3, Azure, Oracle Cloud, more…)', value: 'SaaS' },
    { label: 'Minimum / Maximum Users', value: '10 / Unlimited' },
    { label: 'External Users', value: 'Unlimited' },
    { label: 'File Upload Size', value: 'Unlimited' },
    { label: 'Workflow Automation', value: '3 Workflows Max.' },
    { label: 'Region-Specified, Dedicated Single-Tenant Hosting – Fully Isolated Data-Layer Protection', value: true },
    { label: 'Support for Network Shares with NTFS Integration for VPN-less secure access', value: false },
    { label: 'FIPS 140-3 Compliant Storage Encryption', value: false },
    { label: 'Support compliance requirements for industry security standards (CMMC, NIST 800-53)', value: false },
    { label: 'Optimized Multi-Site Architecture', value: false },
    { label: 'CMMC Compliance Enabled CUI Data Management', value: false },
    { label: 'AWS GovCloud Hosted – Managed by FileCloud', value: false },
  ],
  advanced: [
    { label: 'Base Storage Included', value: '10TB' },
    { label: 'Cloud Platforms Support (AWS S3, Azure, Oracle Cloud, more…)', value: 'SaaS' },
    { label: 'Minimum / Maximum Users', value: '10 / Unlimited' },
    { label: 'External Users', value: 'Unlimited' },
    { label: 'File Upload Size', value: 'Unlimited' },
    { label: 'Workflow Automation', value: true },
    { label: 'Region-Specified, Dedicated Single-Tenant Hosting – Fully Isolated Data-Layer Protection', value: true },
    { label: 'Support for Network Shares with NTFS Integration for VPN-less secure access', value: false },
    { label: 'FIPS 140-3 Compliant Storage Encryption', value: false },
    { label: 'Support compliance requirements for industry security standards (CMMC, NIST 800-53)', value: false },
    { label: 'Optimized Multi-Site Architecture', value: false },
    { label: 'CMMC Compliance Enabled CUI Data Management', value: false },
    { label: 'AWS GovCloud Hosted – Managed by FileCloud', value: 'Optional' },
  ],
  fedramp: [
    { label: 'Base Storage Included', value: '10TB' },
    { label: 'Cloud Platforms Support (AWS S3, Azure, Oracle Cloud, more…)', value: 'SaaS' },
    { label: 'Minimum / Maximum Users', value: '10 / Unlimited' },
    { label: 'External Users', value: 'Unlimited' },
    { label: 'File Upload Size', value: 'Unlimited' },
    { label: 'Workflow Automation', value: true },
    { label: 'Region-Specified, Dedicated Single-Tenant Hosting – Fully Isolated Data-Layer Protection', value: true },
    { label: 'Support for Network Shares with NTFS Integration for VPN-less secure access', value: false },
    { label: 'FIPS 140-3 Compliant Storage Encryption', value: true },
    { label: 'Support compliance requirements for industry security standards (CMMC, NIST 800-53)', value: true },
    { label: 'Optimized Multi-Site Architecture', value: false },
    { label: 'CMMC Compliance Enabled CUI Data Management', value: true },
    { label: 'AWS GovCloud Hosted – Managed by FileCloud', value: true },
  ],
}

export const serverBenefits = {
  essentials: {
    included: [
      'Unlimited Storage',
      'Unlimited Licensed External Users',
      'Support for Network Shares with NTFS Integration for VPN-less secure access.',
    ],
    not_included: [
      'Content Classification & Search',
      'Content Lifecycle Management - Legal Hold, Retention, & Archival',
      'Unlimited Workflows ',
      'Digital Rights Management',
      'Key Integrations - MS Teams, Salesforce, Active Directory & SIEM',
      'Optimized Multi-Site Architecture (high-performance, scalable and redundant data access in distributed data center environments)',
      'Enable compliance with FIPS 140-2, ITAR,  EAR, CJIS,  DoD Cloud Computing SRGs,  IRS-1075 + Other Regulations',
    ]
  },
  advanced: {
    included: [
      'Unlimited Storage',
      'Unlimited Licensed External Users',
      'Support for Network Shares with NTFS Integration for VPN-less secure access.',
      'Content Classification & Search',
      'Content Lifecycle Management - Legal Hold, Retention, & Archival',
      'Unlimited Workflows ',
      'Digital Rights Management',
      'Key Integrations - MS Teams, Salesforce, Active Directory & SIEM',
      'Optimized Multi-Site Architecture (high-performance, scalable and redundant data access in distributed data center environments)',
      'Enable compliance with FIPS 140-2, ITAR,  EAR, CJIS,  DoD Cloud Computing SRGs,  IRS-1075 + Other Regulations',
    ],
    not_included: []
  },
  spla: {
    included: [
      'Unlimited Storage',
      'Unlimited Licensed External Users',
      'Support for Network Shares with NTFS Integration for VPN-less secure access.',
      'Content Classification & Search',
      'Content Lifecycle Management - Legal Hold, Retention, & Archival',
      'Unlimited Workflows ',
      'Digital Rights Management',
      'Key Integrations - MS Teams, Salesforce, Active Directory & SIEM',
      'Optimized Multi-Site Architecture (high-performance, scalable and redundant data access in distributed data center environments)',
    ],
    not_included: [
      'Enable compliance with FIPS 140-2, ITAR,  EAR, CJIS,  DoD Cloud Computing SRGs,  IRS-1075 + Other Regulations',
    ]
  },
}